var _defs, _circle, _circle2, _circle3, _circle4, _g, _line, _circle5, _g2, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediaTechHero(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    role: "img",
    "aria-label": "Media and Tech",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "plate",
    x1: "18%",
    y1: "12%",
    x2: "86%",
    y2: "92%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0A4A82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#004179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000E1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFE566"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C9A000"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 248,
    fill: "#EEF3F8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 236,
    fill: "none",
    stroke: "#FFCF00",
    strokeWidth: 2.5,
    opacity: 0.55
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 208,
    fill: "url(#plate)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 178,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1,
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 214,
    width: 148,
    height: 100,
    rx: 16,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 214 V198 C128 190 134 184 142 184 H170 C178 184 184 190 184 198 V214 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 190,
    width: 22,
    height: 10,
    rx: 3,
    fill: "url(#gold)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 232,
    r: 7,
    fill: "url(#gold)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 264,
    r: 34,
    fill: "#001833"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 264,
    r: 34,
    fill: "none",
    stroke: "url(#gold)",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 264,
    r: 22,
    fill: "#0A4A82"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 264,
    r: 22,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.25,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 264,
    r: 10,
    fill: "#000E1F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 258,
    r: 3.5,
    fill: "#FFE566",
    opacity: 0.9
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 256,
    y1: 178,
    x2: 256,
    y2: 334,
    stroke: "#FFCF00",
    strokeWidth: 2,
    opacity: 0.35,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 4.5,
    fill: "url(#gold)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "url(#gold)",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300 198 L268 256 L300 314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 198 L392 256 L360 314"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 348,
    y1: 210,
    x2: 312,
    y2: 302,
    stroke: "url(#gold)",
    strokeWidth: 9,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaTechHero);
export default __webpack_public_path__ + "static/media/media-tech-hero.cce0aa90e0696418a919d87f556491db.svg";
export { ForwardRef as ReactComponent };